import {
  TransForm
} from '@/assets/js/transform.js'
export const domScrollTop = () => {
  // return new Promise((resolve) => {
    // let app = document.body || document.documentElement
    // 让滚动条在最上方
    // window.scrollTo(0, 0)
    // console.log(app.scrollTop)
    // console.log(window.scrollY)
    // window.scrollTop = 0
    window.scrollY = 0
    // window.scrollTo(0,0)
    // console.log(app.scrollTop)
    // setTimeout(() => {resolve()}, 3000)
    // resolve()
  // })
}

export const computedOrgRole = (orgLink) => {
  // console.log(orgLink)
  if (orgLink) {
    let linkArr = orgLink.split(',')
    if (linkArr.length > 4) {
      return true
    } else {
      return false
    }
  }
}

export const transToBD09 = (coord_type, lng, lat) => {
  // let tmpLat = +lat;
  // let tmpLng = +lng;
  let tmp
  if (coord_type == 'wgs84' || coord_type == 'WGS84') {
    tmp = TransForm.wgs84tobd09(lng, lat)
  } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
    tmp = TransForm.gcj02tobd09(lng, lat)
  } else {
    tmp = [lng, lat]
  }
  tmp = [tmp[0], tmp[1]];
  return {
    coord_type: 'bd09',
    lng: tmp[0],
    lat: tmp[1]
  }
}

// 经纬度转墨卡托投影坐标
/*经纬度转墨卡托投影坐标*/
export const lnglatTomercator = (lng, lat) => {
  let mercator={x:0,y:0}
  let x = lng * 20037508.34 / 180
  let y = Math.log(Math.tan((90+lat)*Math.PI/360))/(Math.PI/180)
  y = y *20037508.34/180
  mercator.x = x
  mercator.y = y
  return mercator
}

// 墨卡托转经纬度坐标
export const mercatorTolnglat = (mercator={x:0,y:0}) => {
  let lng = mercator.x/20037508.34*180
  let lat = mercator.y/20037508.34*180
  lat = 180/Math.PI*(2*Math.atan(Math.exp(lat*Math.PI/180))-Math.PI/2)
  return {
    lng,
    lat
  }
}
export default {
  domScrollTop,
  transToBD09,
  computedOrgRole,
  lnglatTomercator,
}